import { Overlay } from '@src/components/Overlay'
import Trigger from '@src/layouts/shared/Recheck/Trigger'
import { getPaidMember } from '@src/state/auth/selectors'
import { selectForMinTextLength } from '@src/state/document/selectors'
import { handleFreeTrialStart as freeTrialStart } from '@src/state/payment/actions'
import { RootState } from '@src/state/types'
import { useToggle } from '@src/utils/hooks/useToggle'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import GateFreeUser from './GateFreeUser'
import Rechecks from './Rechecks'
import * as Styles from './styles'
import * as Types from './types'

export const UPGRADE_TO_RECHECK = 'UPGRADE_TO_RECHECK'
export const RECHECK_MENU_GRAMMAR = 'RECHECK_MENU_GRAMMAR'
export const RECHECK_MENU_PLAGIARISM = 'RECHECK_MENU_PLAGIARISM'

export const Recheck: React.FunctionComponent<Types.RecheckComponent> = ({
  media,
  isPaidMember,
  handleFreeTrialStart,
  hasMinText,
  checksRunning,
}) => {
  const { value: active, toggle: toggleActive } = useToggle()

  const targetElement = Trigger({ active }) as React.ReactElement

  if (isPaidMember) {
    return (
      <Overlay
        targetElement={targetElement}
        positionCSS={Styles.recheckPositions[media]}
        onToggle={toggleActive}
      >
        <Rechecks hasMinText={hasMinText} checksRunning={checksRunning} />
      </Overlay>
    )
  }
  return (
    <Overlay
      targetElement={targetElement}
      positionCSS={Styles.gatePositions[media]}
      onToggle={toggleActive}
    >
      <GateFreeUser
        point={media === 'giant' ? 'down' : 'up'}
        onClick={handleFreeTrialStart}
      />
    </Overlay>
  )
}

const mapStateToProps = (state: RootState): Types.StateMappedToProps => ({
  isPaidMember: getPaidMember(state),
  hasMinText: selectForMinTextLength(state),
  checksRunning: state.workspace.checksRunning,
})

const mapDispatchToProps = (dispatch: Dispatch): Types.DispatchMappedToProps => ({
  handleFreeTrialStart: () => dispatch(freeTrialStart(UPGRADE_TO_RECHECK)),
})

export default connect<Types.StateMappedToProps, Types.DispatchMappedToProps>(
  mapStateToProps,
  mapDispatchToProps
)(Recheck)



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/index.tsx